import { Box, Button, ButtonProps } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './Button.scss';

interface AppButtonProps extends ButtonProps {
  isLink?: boolean;
  typeName?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'text'
    | 'pending'
    | 'approval'
    | 'final_approval'
    | 'restricted';
}

const AppButton: React.FC<AppButtonProps> = ({
  title,
  type,
  color,
  variant,
  isLink = false,
  sx,
  disabled,
  onClick,
  className = '',
  typeName,
  ...prop
}) => {
  const { t } = useTranslation();
  return (
    <Box className='AppButton'>
      <Button
        variant={variant ?? (isLink ? 'text' : 'contained')}
        color={color}
        disabled={disabled}
        className={`AppButton__content ${className} ${typeName ? typeName : ''}`}
        onClick={onClick}
        type={type}
        sx={sx}
        {...prop}
      >
        {t(title!)}
      </Button>
    </Box>
  );
};

export default AppButton;
